import {
  ORG_SLUG_MAX_LENGTH,
  ORG_SLUG_REGEX,
  RESERVED_ORG_SLUGS
} from '../constants/Validation.constants';

/**
 * Suggests an organization identifier from a display name. Only used to prefill
 * the field — the value stays editable, and it is validated like any other.
 */
export const deriveOrgSlug = (name: string): string =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, ORG_SLUG_MAX_LENGTH)
    .replace(/-+$/, '');

export const validateOrgSlug = (slug: string): string => {
  if (!slug.trim()) return 'Organization ID is required.';

  if (RESERVED_ORG_SLUGS.includes(slug)) {
    return 'This organization ID is reserved.';
  }

  if (!ORG_SLUG_REGEX.test(slug)) {
    return `Use ${ORG_SLUG_MAX_LENGTH} characters or fewer: lowercase letters, numbers and hyphens, starting with a letter or number.`;
  }

  return '';
};
